<div class="pointCF__field pointCF__field--expandable">
  <label class="pointCF__label">
    <div class="pointCF__label-image--container">
      <pp-icon
        [ppSrc]="EIconPath.ICON_FIELDS_PERCENTAGE_18"
        ppColor="inherit"
        ppClass="setSize18"
      />
    </div>

    <span
      ppTooltip
      class="pointCF__label-container"
      ppTitle="{{ ppFieldLabel }}"
      [ppTrimTooltip]="true"
    >
      {{ ppFieldLabel }}
    </span>

    @if (ppFieldDescription) {
      <pp-point-fields-custom-field-description [ppDescription]="ppFieldDescription" />
    }
  </label>

  @if (ppSubfieldsActive) {
    <pp-custom-field-numeric-with-subfields
      [ppPointField]="ppField"
      [ppFieldId]="ppFieldId"
      [ppWorkspaceId]="ppWorkspaceId"
      [ppCanEdit]="ppCanEdit"
      [ppPointId]="ppPointId"
      [ppNew]="ppNew"
      [ppIsLocked]="ppIsLocked"
    />
  } @else {
    <pp-custom-field-cost
      [ppWorkspaceId]="ppWorkspaceId"
      [ppPointId]="ppPointId"
      [ppFieldId]="ppFieldId"
      [ppFieldLabel]="ppFieldLabel"
      ppFieldCurrencySymbol=""
      ppFieldCurrencyCode="%"
      [ppFieldValue]="ppField.value"
      [ppIntegrationStatus]="EIntegrationStatus.OFF"
      [ppNew]="ppNew"
      [ppCanEdit]="ppCanEdit"
      (ppUpdate)="updateField($event)"
      [ppDecimalPlaces]="0"
      [ppIsLocked]="ppIsLocked"
    />
  }
</div>
